<template>
  <div class="announcement-list-skeleton pb-4 mb-6">
    <div class="skeleton-header">
      <div class="skeleton-icon"></div>
      <div class="skeleton-text skeleton-text--header"></div>
    </div>
    <div class="skeleton-items pl-5 pt-2">
      <div class="skeleton-item" v-for="i in 3" :key="i">
        <div class="skeleton-bullet"></div>
        <div class="skeleton-text skeleton-text--link"></div>
        <div class="skeleton-text skeleton-text--date"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'announcement-list-skeleton',
};
</script>

<style lang="sass" scoped>
@keyframes shimmer
  0%
    background-position: -200px 0
  100%
    background-position: 200px 0

.skeleton
  &-header
    display: flex
    align-items: center
    padding: 8px 0
    border-bottom: 1px solid #e0e0e0

  &-icon
    width: 24px
    height: 24px
    border-radius: 4px
    margin-right: 8px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)
    background-size: 400px 100%
    animation: shimmer 1.5s infinite

  &-text
    height: 16px
    border-radius: 4px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)
    background-size: 400px 100%
    animation: shimmer 1.5s infinite

    &--header
      width: 100px

    &--link
      width: 200px
      flex-shrink: 0

    &--date
      width: 40px
      margin-left: 16px

  &-items
    display: flex
    flex-direction: column
    gap: 8px

  &-item
    display: flex
    align-items: center
    padding: 4px 0

  &-bullet
    width: 8px
    height: 8px
    border-radius: 50%
    margin-right: 8px
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)
    background-size: 400px 100%
    animation: shimmer 1.5s infinite
</style>
